/*
 * Constants
 ***************************/
 var $ = jQuery.noConflict()
 const mobileBreakpoint = 767;
 let scrollTop = $(window).scrollTop(),
     navTrigger = 0;

// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
let vh = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty('--vh', `${vh}px`);
window.addEventListener('resize', () => {
 // We execute the same script as before
 let vh = window.innerHeight * 0.01;
 document.documentElement.style.setProperty('--vh', `${vh}px`);
});

const instagramSlickSettings = {
  mobileFirst: true,
  dots: false,
  arrows: false,
  swipe: true,
  centerMode: true,
  slidesToShow: 1,
  centerPadding: '25%',
  responsive: [
    {
      breakpoint: 768,
      settings: 'unslick'
    }
  ]
};

/*
 * Globals
 ***************************/
  /* Window */
    var windowWidth = $(window).width();
    var windowHeight = $(window).height();
    var windowScrollHeight = document.querySelector('body').scrollHeight;
  /* Breakpoints */
    var isMobile = ( windowWidth <= mobileBreakpoint );
  /* Navigation */
    var isMenuOpen = false,
        isTakeoverMenuOpen = false,
        isSearchOpen = false;

  /* Ajax */
    let currentPage = 1;
    let ajaxIsLoading = false;
    let isDoneLoadingThings = false;
    let currentUrl = window.location.href;

  /* Slick Options */
    const prevArrow = '<button type="button" class="slick-big-arrow slick-prev"><span class="screen-reader-text">Previous</span></button>';
    const nextArrow = '<button type="button" class="slick-big-arrow slick-next"><span class="screen-reader-text">Next</span></button>';


const handleKeypressADA = function() {
  const keycode = (event.keyCode ? event.keyCode : event.which);
  if (keycode == '13') return;
  $(this).trigger('click');
};

$(window).on('load', function() {
  windowWidth = $(window).width();
  windowHeight = $(window).height();
  windowScrollHeight = document.querySelector('body').scrollHeight;
});

$(document).ready(function(){
  const motionQuery = window.matchMedia("(prefers-reduced-motion: reduce)");

  /* Generic */
  if ( $('.modal-area').length ) {
    $('.modal-area').each(function(){
      const prop = $(this).data('propid');

      $(this).find('.modal-area__dismiss').on('click', function(){
        $(this).closest('.modal-area').removeClass('active');
        window.localStorage.setItem( prop, 'true' );
      }).on('keypress', handleKeypressADA);

      const element = $(this).get(0);

      $(this).on('click', function(e){
        if (e.target !== element && !element.contains(e.target)) {
          $(this).removeClass('active');
          window.localStorage.setItem( prop, 'true' );
        }
      });

      const modalDismissed = window.localStorage.getItem( prop );
      if ( modalDismissed != 'true' ) {
        const modal = $(this);
        setTimeout(function(){
          modal.addClass('active');
        }, $(this).data('delay'));
      }
    });
  }

  if ( $('.smooth-scroller').length ) { // internal links, smooth scrolling
    $('.smooth-scroller').on('click', function(e){
      e.preventDefault();
      let target = $( $(this).attr('href') ).offset().top - 148;
      let dist = Math.abs($(window).scrollTop() - target);

      $([document.documentElement, document.body]).animate({
        scrollTop: target
      }, Math.min(1200, ((dist / 1200) * 1000)));
    }).on('keypress', handleKeypressADA);
  }

  if ( $('.copybutton').length ) {
    $('.copybutton').on('click', function(e){
      e.preventDefault();
      const targetEl = $( $(this).data('target') ).get(0);
      const alertEl = $( $(this).data('alert') ).get(0);
      targetEl.select()
      targetEl.setSelectionRange(0, 9999999);
      document.execCommand("copy");
      $(alertEl).fadeIn();
      setTimeout(function(){
        $(alertEl).fadeOut();
      }, 6000);
    }).on('keypress', handleKeypressADA);
  }

  if ( $('.modaltrigger').length ) {
    $('.modaltrigger').on('click', function(e){
      e.preventDefault();
      $(this).addClass('active');
      $(this).attr('aria-expanded', true );
      $($(this).attr('href')).addClass('active');
      $('#masthead').removeClass('scrolled-back');
      $('#masthead').addClass('scrolled');
      $('body').addClass('no-scroll');
    }).on('keypress', handleKeypressADA);
  }

  if ( $('.modalclose').length ) {
    $('.modalclose').on('click', function(e){
      e.preventDefault();
      const controlledBy = $(this).data('controlledby');
      $(this).closest('.modal').removeClass('active');
      $(controlledBy).removeClass('active');
      $(controlledBy).attr('aria-expanded', false);
      $('body').removeClass('no-scroll');
    }).on('keypress', handleKeypressADA);
  }
  /* END GENERIC SCRIPTS */

  /* Navigation */
  if ( $('.main-navigation__toggle').length ) {
    $('.main-navigation__toggle').on('click', function(){
      $(this).toggleClass('active');
      $('#site-navigation-inner').toggleClass('active');
      $('body').toggleClass('no-scroll');
    }).on('keypress', handleKeypressADA);
  }

  if ( $('.main-navigation__menu > .menu-item').length ) {
    $('.main-navigation__menu > .menu-item').each(function(index) {
      $(this).css('transition-delay', ((index * 60) + 120) + 'ms');
      if ( $(this).find('.menu-item').length ) {
        const submenu = $(this).find('.sub-menu');
        submenu.hide();

        $(this).children('a').on('click', function(e){
          e.preventDefault();
          $(this).toggleClass('active');
          submenu.slideToggle();
        }).on('keypress', handleKeypressADA);

        $(this).find('.menu-item').each(function(indexInner) {
          $(this).css('transition-delay', ( (((index + 1) * 60) + ( indexInner * 30) ) + 120) + 'ms');
        });
      }
    });
  }

  if ( $('.has-hover-background').length ) {
    $('.has-hover-background').on('mouseover', function() {
      const target = $(this).data('imgid');
      $('#main-navigation__background-' + target).addClass('active');
      $('#main-navigation__background-main').addClass('out');
    });

    $('.has-hover-background').on('mouseout', function() {
      const target = $(this).data('imgid');
      $('#main-navigation__background-' + target).removeClass('active');
      $('#main-navigation__background-main').removeClass('out');
    });
  }
  /* END NAVIGATION SCRIPTS */

  /* GUTENBERG BLOCK SCRIPTS */
  // gallery
  if ( $('.wp-block-gallery').length ) {
    $('.wp-block-gallery').each(function(){
      gutenbergSlickify(this);
    });
  }
  /* END GUTENBERG SCRIPTS */

  /* HOME SCRIPTS */
  if ( $('.home-carousel').length ) {
    $('.home-carousel').each(function(){
      const slides = $(this).find('.home-carousel__slides');
      const nav = $(this).find('.home-carousel__nav-item__link');

      slides.slick({
        prevArrow: prevArrow,
        nextArrow: nextArrow,
        autoplay: true,
        autoplaySpeed: 2000,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              arrows: false
            }
          }
        ]
      });

      slides.on('beforeChange', function(event, slick, currentSlide, nextSlide){
        nav.removeClass('active');
        nav.eq(nextSlide).addClass('active');
      });

      nav.each(function(index){
        $(this).on('click', function(e){
          e.preventDefault();
          slides.slick('slickGoTo', index);
        }).on('keypress', handleKeypressADA);
      });
    });
  }

  if ( $('.homepage-buzz__highlights').length ) {
    $('.homepage-buzz__highlights').each(function(){
      const buzzSlickSettings = {
        mobileFirst: true,
        dots: true,
        arrows: false,
        appendDots: $(this).siblings('.homepage-buzz__highlights__dotcontainer'),
        responsive: [
          {
            breakpoint: 768,
            settings: 'unslick'
          }
        ]
      };

      $(this).slick(buzzSlickSettings);
    });
  }

  if ( $('#sbi_images').length ) {
    $('#sbi_images').each(function(){

      $(this).slick(instagramSlickSettings);
    });
  }
  /* END HOME SCRIPTS */

  /* Restaurant Scripts */
  if ( $('.restaurant-location').length ) {
    $('.restaurant-location').each(function(){
      const slickContainer = $(this).find('.restaurant-location__slick');
      const links = $(this).find('.restaurant-location__list-item__link');

      $(slickContainer).slick({
        fade: true,
        arrows: false,
        infinite: false,
        swipe: false,
        draggable: false,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              infinite: false,
              fade: false,
              arrows: true,
              centerMode: true,
              slidesToShow: 1,
              adaptiveHeight: true,
              prevArrow: prevArrow,
              nextArrow: nextArrow
            }
          }
        ]
      });

      $(this).find('.restaurant-location__slick-item').each(function(index){
        if ( $(this).hasClass('active') ) {
          $(slickContainer).slick('slickGoTo', index);
        }
      });

      links.each(function(index){
        $(this).on('click', function(e){
          e.preventDefault();
          $(slickContainer).slick('slickGoTo', index);
        }).on('keypress', handleKeypressADA);
      });

      $(slickContainer).on('beforeChange', function(event, slick, currentSlide, nextSlide){
        $(links).removeClass('active');
        $(links).eq(nextSlide).addClass('active');
      });
    });
  } // if .restaurant-location

  if ( $('.restaurant-related__list').length ) {
    $('.restaurant-related__list').each(function(){
      $(this).slick({
        centerMode: true,
        slidesToShow: 5,
        variableWidth: true,
        prevArrow: prevArrow,
        nextArrow: nextArrow,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              centerMode: false,
              slidesToShow: 1,
              variableWidth: false
            }
          }
        ]
      });
    });
  }
  /* END RESTAURANT SCRIPTS */

  /* RESTAURANT ARCHIVE SCRIPTS */
  if ( $('.restaurant-archive__loclist__toggle').length ) {
    $('.restaurant-archive__loclist__toggle').on('click', function(){
      $(this).next().slideToggle();
      $(this).toggleClass('active');
    }).on('keypress', handleKeypressADA);
  }
  /* END RESTAURANT ARCHIVE SCRIPTS */

  /* SINGLE PAGE HEADER ANIMATIONS */
  if ( $('.page-header__inner-card').length ) {
    $('.page-header__inner-card').each(function(){
      const textAreas = $(this).find('.page-header__title, .page-header__inner-card__content > *').get();
      console.log(textAreas);

      new SplitText(textAreas, {
        type: 'lines',
        linesClass: 'ha-line__inner'
      });

      $(this).find('.ha-line__inner').each(function(){
        $(this).wrap('<div class="ha-line"></div>');
      });

      const lines = $(this).find('.ha-line__inner').get();

      gsap.set(lines, {
        y: '100%',
        rotate: '8deg',
        transformOrigin: 'left top'
      });

      setTimeout(function(){
        gsap.to(lines, {
          y: '0%',
          rotate: '0deg',
          transformOrigin: 'left top',
          duration: 0.3,
          stagger: 0.08,
          ease: 'power2.out'
        });
      }, 300);
    });
  }
  /* END SINGLE PAGE HEADER ANIMATIONS */

  /* SCROLL ANIMATIONS */
  if ( !motionQuery.matches ) {
    if ( $('.content-container').length ) {
      $('.content-container > *, .st-fadein').each(function(){
        $(this).addClass('st-setup');

        if ( $(this).hasClass("st-fadein__batch-parent") && ($(this).find('.st-fadein__batch').length > 0) ) {
          console.log($(this).find('.st-fadein__batch').get());
          const batchTrigger = gsap.from($(this).find('.st-fadein__batch').get(), {
            opacity: 0,
            y: isMobile ? 32 : 128,
            ease: 'power2.out',
            stagger: 0.15,
            scrollTrigger: {
              start: 'top bottom',
              end: 'top 60%',
              trigger: this,
              once: true
            }
          })
        } else if ( ! $(this).hasClass('st-nofade') ) {
          const fadeTrigger = gsap.from(this, {
            opacity: 0,
            y: isMobile ? 32 : 128,
            ease: 'power2.out',
            scrollTrigger: {
              start: 'top bottom',
              end: 'top 80%',
              trigger: this,
              once: true
            }
          });
        }


        const animTrigger = gsap.from(this, {
          scrollTrigger: {
            start: 'top 80%',
            end: 'bottom top',
            trigger: this,
            endTrigger: '.content-container',
            toggleClass: 'st-setup__active',
            once: true
          }
        });
      });
    }
  }
  /* END SCROLL ANIMATIONS */
}); // document ready end

/*
 * Window Resize
 ***************************/
$(window).resize(function(){
  windowWidth = $(window).width();
  windowHeight = $(window).height();
  windowScrollHeight = document.querySelector('body').scrollHeight;
  isMobile = ( windowWidth <= mobileBreakpoint );

  if ( $('.homepage-buzz__highlights').length ) {
    if ( isMobile ) {
      $('.homepage-buzz__highlights').each(function(){
        const buzzSlickSettings = {
          mobileFirst: true,
          dots: true,
          arrows: false,
          appendDots: $(this).siblings('.homepage-buzz__highlights__dotcontainer'),
          responsive: [
            {
              breakpoint: 768,
              settings: 'unslick'
            }
          ]
        };

        $(this).slick(buzzSlickSettings);
      });
    }
  }

  if ( $('#sbi_images').length ) {
    if ( isMobile ) {
      $('#sbi_images').each(function(){
        $(this).slick(instagramSlickSettings);
      });
    }
  }
}); // end window resize functions

/*
 * Window Scroll
 ***************************/
$(window).on('scroll', function() {
  navTrigger = scrollTop;
  scrollTop = $(this).scrollTop();

  if ( scrollTop > navTrigger && scrollTop > 0 ) {
    $('.site-header').addClass('scrolled');
    $('.site-header').removeClass('scrolled-back');
  } else {
    $('.site-header').removeClass('scrolled');
    $('.site-header').addClass('scrolled-back');
  }

}); // end window scroll functions

/*
 * Functions
 ***************************/
function gutenbergSlickify(el) {
  const count = $(el).find('figure').length;

  $(el).find('figure').each(function(){
    if ( $(this).find('figcaption').length ) {
      $(this).addClass('has-caption');
    }
  });

  $(el).find('.wp-block-image').each(function(){
    $(this).removeClass('wp-block-image').wrap('<div class="slick-gallery-item"></div>');
  });

  $(el).find('figcaption').each(function(){
    $(this).addClass('slick-gallery-item__caption');
  });

  $(el).addClass('slick-gallery-grid').removeClass('blocks-gallery-grid');

  // $(el).parent().addClass('slick-gallery').removeClass('wp-block-gallery').append('<div class="slick-gallery-nav"><div class="slick-gallery-nav__count"><b><span class="slick-gallery-nav__count__cur">1</span></b> of <b>' + count +'</b></div></div>');

  $(el).wrap('<div></div>');
  $(el).removeClass('wp-block-gallery');
  const parent = $(el).parent();
  $(parent).addClass('alignfull');
  parent.addClass('slick-gallery').append('<div class="slick-gallery-nav"><div class="slick-gallery-nav__count"><b><span class="slick-gallery-nav__count__cur">1</span></b> of <b>' + count +'</b></div></div>');

  const nav = $(el).parent().find('.slick-gallery-nav');

  $(el).slick({
    adaptiveHeight: true,
    prevArrow: '<button type="button" class="slick-gallery-arrow slick-prev"><span class="screen-reader-text">Previous</span></button>',
    nextArrow: '<button type="button" class="slick-gallery-arrow slick-next"><span class="screen-reader-text">Previous</span></button>',
    appendArrows: nav
  });

  $(el).on('beforeChange', function(event, slick, currentSlide, nextSlide){
    nav.find('.slick-gallery-nav__count__cur').text(nextSlide + 1);
  });
}
